import React from "react";
import {
  Typography,
  Container,
  Box,
  Avatar,
  Grid,
  Paper,
  Button,
  Slide,
  Fade,
} from "@mui/material";
import TeamIcon from "@mui/icons-material/Group";
import MissionIcon from "@mui/icons-material/Flag";
import VisionIcon from "@mui/icons-material/Visibility";
import Colorapps from "../../../configcss/color";
import Navbar from "../../../Components/Navbar";
import Footer from "../../../Components/Footer";

const About = () => {
  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <Box
        sx={{
          height: "400px",
          color: Colorapps.textprimary,
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), 
                         url('https://images.pexels.com/photos/7693153/pexels-photo-7693153.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container maxWidth="md">
        <Typography
  variant="h2"
  gutterBottom
  sx={{
    fontWeight: 700,
    color: "#fff",
    textShadow: "2px 2px 4px rgba(0,0,0,0.4)",
  }}
>
  Welcome to Our Journey
</Typography>
<Typography
  variant="h6"
  sx={{ mb: 4, fontWeight: 300, color: "#ddd" }}
>
  We are committed to excellence, innovation, and building strong connections with our clients and community.
</Typography>
<Button
  variant="contained"
  sx={{
    bgcolor: Colorapps.themeprimary,
    ":hover": { bgcolor: Colorapps.themeaccent },
    px: 4,
    py: 1.5,
    fontWeight: 600,
  }}
>
  Learn More
</Button>

        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        {/* Heading Section */}
        <Box
          sx={{
            textAlign: "center",
            mt: 4,
            py: 4,
            backgroundImage: `linear-gradient(to right, ${Colorapps.themeprimary}, ${Colorapps.themesecondary})`,
            borderRadius: "10px",
            color: Colorapps.textprimary,
          }}
        >
          <Typography variant="h3" gutterBottom>
            About Us
          </Typography>
          <Typography variant="h6" paragraph>
            We are a passionate team dedicated to making a difference. Our goal
            is to provide exceptional service and create lasting relationships
            with our clients.
          </Typography>
        </Box>

        {/* Mission, Vision, Values Section */}
        <Grid container spacing={4} justifyContent="center" sx={{ mt: 4 }}>
          {[
            {
              icon: <MissionIcon fontSize="large" />,
              title: "Our Mission",
              description:
                "To deliver value through innovation, creating a positive impact on communities worldwide.",
              color: Colorapps.themeprimary,
            },
            {
              icon: <VisionIcon fontSize="large" />,
              title: "Our Vision",
              description:
                "To be a leading force in our industry, driven by passion and innovation.",
              color: Colorapps.themesecondary,
            },
            {
              icon: <TeamIcon fontSize="large" />,
              title: "Our Values",
              description:
                "Integrity, innovation, and inclusivity are at the heart of everything we do.",
              color: Colorapps.themeaccent,
            },
          ].map((item, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              sx={{ display: "flex" }}
            >
              <Slide direction="up" in={true} timeout={800 + index * 200}>
                <Paper
                  elevation={3}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 3,
                    textAlign: "center",
                    borderRadius: "15px",
                    backgroundColor: item.color,
                    color: Colorapps.textprimary,
                    height: "100%",
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "white",
                      mb: 2,
                      color: item.color,
                    }}
                  >
                    {item.icon}
                  </Avatar>
                  <Typography variant="h5" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography>{item.description}</Typography>
                </Paper>
              </Slide>
            </Grid>
          ))}
        </Grid>
        <br />
        {/* Team Section */}
        {/* Team Section */}
        <Box
          sx={{
            mt: 6,
            mb: 6,
            py: 6,
            px: 4,
            background: `linear-gradient(to bottom right, ${Colorapps.themeprimary}, ${Colorapps.themesecondary})`,
            borderRadius: "15px",
            color: Colorapps.textprimary,
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          }}
        >
          <Typography
            variant="h4"
            align="center"
            sx={{ color: Colorapps.textprimary, fontWeight: "bold", mb: 4 }}
          >
            Meet Our Team
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6,
            }}
          >
            {/* CEO */}
            <Box
              sx={{
                display: "flex",
                width: "500px",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                position: "relative",
                background: Colorapps.backgroundlight,
                padding: 4,
                borderRadius: "15px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Avatar
                src="https://randomuser.me/api/portraits/men/1.jpg"
                sx={{
                  width: 120,
                  height: 120,
                  border: `4px solid ${Colorapps.themeprimary}`,
                }}
              />
              <Typography
                variant="h5"
                sx={{ color: Colorapps.themeprimary, fontWeight: "bold" }}
              >
                CEO Name
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Chief Executive Officer
              </Typography>
              <Typography
                variant="h6"
                color="textSecondary"
                sx={{ textAlign: "center", mt: 2, px: 2, fontStyle: "italic" }}
              >
                "Our journey is defined by the dedication of our team and the
                trust of our clients. Together, we innovate, inspire, and
                achieve excellence every day. Here's to building a future that
                we can all be proud of."
              </Typography>
            </Box>

            {/* Managers */}
            <Typography
              variant="h5"
              align="center"
              sx={{
                color: Colorapps.textprimary,
                fontWeight: "bold",
                mt: 4,
              }}
            >
              Management Team
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 4,
                flexWrap: "wrap",
              }}
            >
              {[1, 2].map((manager, index) => (
                <Paper
                  key={index}
                  elevation={3}
                  sx={{
                    padding: 3,
                    textAlign: "center",
                    borderRadius: "15px",
                    transition: "transform 0.2s",
                    "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
                    bgcolor: Colorapps.backgroundlight,
                    color: Colorapps.textsecondary,
                    width: "200px",
                  }}
                >
                  <Avatar
                    src={`https://randomuser.me/api/portraits/men/${
                      10 + index
                    }.jpg`}
                    sx={{ width: 80, height: 80, mx: "auto", mb: 2 }}
                  />
                  <Typography variant="h6" gutterBottom>
                    Manager {index + 1}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Department Manager
                  </Typography>
                </Paper>
              ))}
            </Box>

            {/* HR Team */}
            <Typography
              variant="h5"
              align="center"
              sx={{
                color: Colorapps.textprimary,
                fontWeight: "bold",
                mt: 4,
              }}
            >
              HR Team
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 4,
                flexWrap: "wrap",
              }}
            >
              {[1, 2, 3].map((hr, index) => (
                <Paper
                  key={index}
                  elevation={3}
                  sx={{
                    padding: 3,
                    textAlign: "center",
                    borderRadius: "15px",
                    transition: "transform 0.2s",
                    "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
                    bgcolor: Colorapps.backgroundlight,
                    color: Colorapps.textsecondary,
                    width: "180px",
                  }}
                >
                  <Avatar
                    src={`https://randomuser.me/api/portraits/women/${
                      15 + index
                    }.jpg`}
                    sx={{ width: 60, height: 60, mx: "auto", mb: 2 }}
                  />
                  <Typography variant="body1" gutterBottom>
                    HR {index + 1}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    HR Specialist
                  </Typography>
                </Paper>
              ))}
            </Box>
          </Box>
        </Box>

        {/* Contact Section */}
        <Box
          sx={{
            textAlign: "center",
            mt: 6,
            pt: 4,
            pb: 4,
            bgcolor: Colorapps.themeprimary,
            color: Colorapps.textprimary,
            borderRadius: "10px",
          }}
        >
          <Typography variant="h4" gutterBottom>
            Get In Touch
          </Typography>
          <Typography variant="body1">
            We would love to hear from you. Reach out to learn more about our
            services and how we can help you.
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 2, bgcolor: Colorapps.themeaccent }}
          >
            Contact Us
          </Button>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default About;
